import React from 'react';
import { Box, HStack, Text } from '@chakra-ui/react';
import { useConfig } from '@app/config';
import { FeaturedCollection } from '@app/screens/nft-marketplace/RewardNfts/FeaturedCollection';

export const FeaturedCollections = () => {
  const config = useConfig();

  return (
    <Box
      sx={{
        borderRadius: '12px',
        border: '1px solid',
        borderColor: 'neutral.700',
        padding: ['12px'],
        marginBottom: '32px'
      }}
    >
      <HStack justify="space-between" mb={3}>
        <Text fontSize={16} color="white">
          Featured Rewards NFT Collections
        </Text>
      </HStack>
      <HStack gap={3}>
        {config?.NFT_MARKETPLACE.rewardNftsWhitelist.map((address, i) => {
          return <FeaturedCollection key={address} contractAddress={address} />;
        })}
      </HStack>
    </Box>
  );
};
